import React from 'react';
import { Link, NavigateFunction } from 'react-router-dom';
import { withRouter } from '../utils/withRouter';
import { User } from '../types';
import { FiBriefcase, FiGrid, FiFilePlus, FiLogOut, FiSettings } from 'react-icons/fi';
import packageJson from '../../package.json';
import './Layout.css';

const APP_VERSION = process.env.REACT_APP_VERSION || packageJson.version || '0.1.0';

export interface LayoutProps {
    user: User;
    onLogout: () => void;
    children: React.ReactNode;
}

interface LayoutPropsWithRouter extends LayoutProps {
    location: { pathname: string };
    navigate: NavigateFunction;
}

class Layout extends React.Component<LayoutPropsWithRouter> {
    isActive = (path: string): string => {
        return this.props.location.pathname === path ? 'active' : '';
    }

    render() {
        const { children, user, onLogout } = this.props;

        return (
            <div className="layout-container">
                <aside className="sidebar">
                    <div className="sidebar-header">
                        <div className="logo">
                            <span className="logo-icon"><FiBriefcase /></span>
                            <h2>
                                Peritaciones
                                <span className="app-version">v{APP_VERSION}</span>
                            </h2>
                        </div>
                    </div>

                    <nav className="sidebar-nav">
                        <Link to="/" className={`nav-item ${this.isActive('/')}`}>
                            <span className="icon"><FiGrid /></span>
                            Dashboard
                        </Link>
                        <Link to="/create" className={`nav-item ${this.isActive('/create')}`}>
                            <span className="icon"><FiFilePlus /></span>
                            Nuevo Informe
                        </Link>
                        <Link to="/configuracion" className={`nav-item ${this.isActive('/configuracion')}`}>
                            <span className="icon"><FiSettings /></span>
                            Configuración
                        </Link>
                    </nav>

                    <div className="sidebar-footer">
                        <div className="user-profile">
                            <div className="user-info">
                                <span className="user-name">{user?.name}</span>
                                <span className="user-email">{user?.email}</span>
                            </div>
                        </div>
                        <button onClick={onLogout} className="logout-btn-sidebar">
                            <span className="icon"><FiLogOut /></span>
                            Cerrar Sesión
                        </button>
                    </div>
                </aside>

                <main className="main-content">
                    <div className="content-wrapper">
                        {children}
                    </div>
                </main>
            </div>
        );
    }
}

export default withRouter(Layout);
